import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import {
	StyledSelect,
	Label,
	ButtonValue,
	ButtonIcon,
	Color,
	Options,
	OptionsHeader,
	OptionsList,
	ButtonOption,
	ButtonBack,
} from './styles';
import Utils from '../../../../utils';

interface SelectProps {
	label: string;
	value: string;
	options: {
		value: string;
		label: string | React.ReactNode;
	}[];
	onChange: (param: string) => void;
	isFontSelect?: boolean;
	isColorSelect?: boolean;
	isLineHeightSelect?: boolean;
}

const Select = ({
	label,
	value,
	options,
	onChange,
	isColorSelect,
	isFontSelect,
	isLineHeightSelect,
}: SelectProps) => {
	const [isOptionsDisplayed, setIsOptionsDisplayed] = React.useState(false);

	const getDisplayedValue = (value: string): string | React.ReactNode => {
		if (isFontSelect) {
			return (
				<span style={{ fontFamily: value }}>
					{value.split(',')[0].replace(/\'|\"/g, '')}
				</span>
			);
		}

		if (isColorSelect) {
			return <Color style={{ backgroundColor: value }}/>;
		}

		if (isLineHeightSelect && value === 'normal') {
			return <Translate value="messages.normal" />;
		}

		return value;
	};

	return (
		<StyledSelect isFontSelect={isFontSelect}>
			<Label value={label} />
			<ButtonValue
				type="button"
				onClick={() => setIsOptionsDisplayed(true)}
			>
				{getDisplayedValue(value)}
			</ButtonValue>
			<ButtonIcon
				type="button"
				onClick={() => setIsOptionsDisplayed(true)}
			>
				{Utils.getSvgIcon('iconset_back')}
			</ButtonIcon>
			{isOptionsDisplayed &&
				<Options>
					<OptionsHeader>
						<ButtonBack
							type="button"
							onClick={() => setIsOptionsDisplayed(false)}
						>
							{Utils.getSvgIcon('iconset_back')}
							<Translate value="messages.text" />
						</ButtonBack>
						<Translate value={label} />
					</OptionsHeader>
					<OptionsList>
						{options.map(option => {
							const isSelected = value === option.value;
							return (
								<li key={option.value}>
									<ButtonOption
										type="button"
										onClick={() => onChange(option.value)}
									>
										{isSelected && Utils.getSvgIcon('iconset_uprez_check')}
										{option.label}
									</ButtonOption>
								</li>
							);
						})}
					</OptionsList>
				</Options>
			}
		</StyledSelect>
	);
};

export default Select;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/Select/index.tsx